import { createAsyncThunk } from '@reduxjs/toolkit';
import dashboardService from '../../services';

export const provideAiFeedback = createAsyncThunk(
  'product/provideAiFeedback',
  dashboardService.provideAiFeedback,
);
